import {
    GetTrashParams,
    RestoreTrashParams,
    PermanentDeleteTrashParams,
    EmptyTrashParams,
} from "../types/requestInputs";
import { GetTrashResponse } from "../types/requestsOutputs";
import { MessageResponse } from "../types/types";
import { fetchAPI } from "./utils";

// Trash (Corbeille): soft-deleted content & projects, scoped per content type. Owner only.
export const getTrash = async ({
    token,
    itemType,
    page = 1,
    limit = 20,
    query,
    kind,
}: GetTrashParams): Promise<GetTrashResponse> => {
    return fetchAPI<GetTrashResponse>("/get-trash", "POST", { itemType, page, limit, query, kind }, token);
};

export const restoreTrashItem = async ({ token, id, kind, itemType }: RestoreTrashParams): Promise<MessageResponse> => {
    return fetchAPI<MessageResponse>("/restore-trash", "POST", { id, kind, itemType }, token);
};

export const permanentDeleteTrashItem = async ({
    token,
    id,
    kind,
    itemType,
}: PermanentDeleteTrashParams): Promise<MessageResponse> => {
    return fetchAPI<MessageResponse>("/permanent-delete-trash", "POST", { id, kind, itemType }, token);
};

export const emptyTrash = async ({ token, itemType }: EmptyTrashParams): Promise<MessageResponse> => {
    return fetchAPI<MessageResponse>("/empty-trash", "POST", { itemType }, token);
};
